/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Promise_1_DetailInputs */

const en_cap_promise_1_detail = /** @type {(inputs: Cap_Promise_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grounded in your own documents and records.`)
};

const lv_cap_promise_1_detail = /** @type {(inputs: Cap_Promise_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balstīta Jūsu dokumentos un ierakstos.`)
};

/**
* | output |
* | --- |
* | "Grounded in your own documents and records." |
*
* @param {Cap_Promise_1_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_promise_1_detail = /** @type {((inputs?: Cap_Promise_1_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Promise_1_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_promise_1_detail(inputs)
	return en_cap_promise_1_detail(inputs)
});